export const PROVIDER_ASSOCIATION_ROUTES = {
  get: '/provider_employer_associations/employer/{employer_id}',
  // [MCV-1826] Employer-side removal; the server limits it to the account owner.
  delete: '/provider_employer_associations/employer/{employer_id}/associations/{association_id}',
};

// [MCV-1927] Previous providers (ended associations).
export const PROVIDER_ASSOCIATION_HISTORY_ROUTES = {
  get: '/provider_employer_associations/employer/{employer_id}/history',
};

// [MCV-1927] Provider-only: the signed-in provider's previous employers.
export const PROVIDER_ASSOCIATION_PROVIDER_HISTORY_ROUTES = {
  get: '/provider_employer_associations/provider/history',
};

export const PROVIDER_ASSOCIATION_INVITATIONS_ROUTES = {
  get: '/provider_employer_associations/employer/{employer_id}/invitations',
  delete: '/provider_employer_associations/employer/{employer_id}/invitations/{invitation_id}',
};

export const PROVIDER_ASSOCIATION_INVITATION_RESEND_ROUTES = {
  post: '/provider_employer_associations/employer/{employer_id}/invitations/{invitation_id}/resend',
};

export const PROVIDER_ASSOCIATION_INVITE_ROUTES = {
  post: '/provider_employer_associations/invite',
};

// [MCV-1894] Employer-managed vaults.
export const PROVIDER_ASSOCIATION_LOOKUP_BY_NPI_ROUTES = {
  get: '/provider_employer_associations/lookup_by_npi/{npi}',
};

export const PROVIDER_ASSOCIATION_ADD_MANAGED_ROUTES = {
  post: '/provider_employer_associations/add_managed_provider',
};

export const PROVIDER_ASSOCIATION_INVITE_MANAGED_ROUTES = {
  post: '/provider_employer_associations/{association_id}/invite_managed',
};

export const PROVIDER_ASSOCIATION_VERIFY_ROUTES = {
  get: '/provider_employer_associations/verify/{code}',
};

// [MCV-1804] Provider-only: is the signed-in provider the one this invitation was sent to.
export const PROVIDER_ASSOCIATION_RECIPIENT_ROUTES = {
  get: '/provider_employer_associations/invitations/{code}/recipient',
};

export const PROVIDER_ASSOCIATION_ACCEPT_ROUTES = {
  post: '/provider_employer_associations/accept',
};

export const PROVIDER_ASSOCIATION_CURRENT_ROUTES = {
  get: '/provider_employer_associations/provider/current',
};

export const PROVIDER_ASSOCIATION_DISASSOCIATE_ROUTES = {
  delete: '/provider_employer_associations/disassociate',
};
